import {type PropsWithChildren} from 'react';
import {Dialog, DialogBackdrop, DialogPanel} from '@headlessui/react';
import {classNames} from 'utils';

interface IModalProps extends PropsWithChildren {
  visible: boolean;
  onClose: () => void;
  backdropClose?: boolean;
  size?: 'large' | 'normal';
  scrollable?: boolean;
  fullHeight?: boolean;
}

const Modal = ({children, visible, onClose, backdropClose = true, size = 'normal', scrollable = true, fullHeight = false}: IModalProps) => {
  return (
    <Dialog open={visible} onClose={backdropClose ? onClose : () => {}} className="relative z-50 no-scrollbar">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500/75 transition-opacity data-closed:opacity-0 data-enter:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in"
      />
      <div className="fixed inset-0 z-10 w-screen h-screen">
        <div className={classNames('flex h-full justify-center items-center p-3 text-center lg:pt-10', fullHeight ? 'lg:pb-20' : 'lg:pb-40')}>
          <DialogPanel
            transition
            className={classNames(
              'relative max-h-full rounded-lg p-4 sm:p-6 text-left shadow-xl transition-all no-scrollbar',
              'transform data-closed:translate-y-4 data-closed:opacity-0 data-enter:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in data-closed:sm:translate-y-0 data-closed:sm:scale-95',
              'bg-white dark:bg-darkBg w-full',
              size === 'large' ? 'sm:max-w-5xl' : 'sm:max-w-lg',
              scrollable && 'overflow-y-scroll',
              fullHeight ? 'h-full ' : 'h-fit',
            )}>
            {children}
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
};

export default Modal;
